import { CreateCSSProperties } from '@material-ui/core/styles/withStyles'

/**
 * Shared thin, token-driven scrollbar for MAX scroll containers: 6px, a subtle thumb and a
 * transparent track. Spread into a makeStyles rule that also sets an overflow.
 *
 * Firefox only honours `scrollbar-color` here (`scrollbar-width` takes no pixel value), so it
 * keeps its default width with the custom colours.
 */
export const customScrollbarStyles: CreateCSSProperties = {
  scrollbarColor:
    'var(--ds-scrollbar-thumb, rgba(15, 23, 42, 0.2)) var(--ds-scrollbar-track, transparent)',
  '&::-webkit-scrollbar': {
    width: 'var(--ds-scrollbar-width, 6px)',
  },
  '&::-webkit-scrollbar-track': {
    background: 'var(--ds-scrollbar-track, transparent)',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'var(--ds-scrollbar-thumb, rgba(15, 23, 42, 0.2))',
    borderRadius: 10,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: 'var(--ds-scrollbar-thumb-hover, rgba(15, 23, 42, 0.3))',
  },
}
